import { supabase } from "@/integrations/supabase/client";

export type BrandLogo = {
  id: string;
  key: string;
  name: string;
  alt: string | null;
  image_url: string | null;
  sort_order: number;
  active: boolean;
};

export async function fetchBrandLogos(includeInactive = false): Promise<BrandLogo[]> {
  let q = supabase.from("brand_logos").select("*").order("sort_order").order("name");
  if (!includeInactive) q = q.eq("active", true);
  const { data, error } = await q;
  if (error) throw error;
  return (data ?? []) as BrandLogo[];
}
